import { connect } from 'react-redux';
import { compose, setDisplayName, lifecycle, pure } from 'recompose';
import { createSelector } from 'reselect';

import Home from '../../views/Home';
import {
  loadNews,
  loadNewsSticky,
  loadNewsHighlight,
  loadNewsMore,
  likeNews,
  refreshNews
} from '../../../actions';
import {
  selectNewsHome,
  selectFeaturedNew,
  selectCurrentPage,
  selectTotalNews,
  selectMoreNews,
  selectNewsSticky
} from '../../../selectors';

export default compose(
  setDisplayName('HomeContainer'),
  connect(
    createSelector(
      selectNewsHome(),
      selectFeaturedNew(),
      selectCurrentPage(),
      selectTotalNews(),
      selectMoreNews(),
      selectNewsSticky(),
      (
        news,
        newFeatured,
        newsCurrentPage,
        newsTotal,
        newsMore,
        newsSticky
      ) => ({
        news,
        newFeatured,
        newsCurrentPage,
        newsTotal,
        newsMore,
        newsSticky
      })
    ),
    {
      loadNews,
      loadNewsMore,
      loadNewsSticky,
      loadNewsHighlight,
      refreshNews,
      onLike: likeNews
    }
  ),
  lifecycle({
    componentDidMount() {
      this.props.loadNews();
      this.props.loadNewsSticky();
      this.props.loadNewsHighlight();
    }
  }),
  pure
)(Home);
